// 吃瓜透视局 站点展示数据
// 均为传播现象/营销机制的观察性示例内容，非针对真实个人的事实指控。

export interface HotItem {
  rank: number;
  tag: string;
  title: string;
  brief: string;
  heat: string;
}

export interface Article {
  id: string;
  category: string;
  date: string;
  readMin: string;
  cover: string;
  title: string;
  excerpt: string;
  body: string[];
}

export interface Pillar {
  icon: string;
  title: string;
  tag: string;
  desc: string;
}

export interface PlaybookStep {
  no: string;
  title: string;
  desc: string;
  hint: string;
}

export interface Tip {
  icon: string;
  title: string;
  desc: string;
}

export interface Faq {
  q: string;
  a: string;
}

export interface Review {
  name: string;
  role: string;
  quote: string;
}

export const hotList: HotItem[] = [
  { rank: 1, tag: "品牌翻车", title: "某国货美妆直播间「道歉式带货」翻车复盘", brief: "从道歉到上链接仅隔 3 分钟，戏剧感拉满，营销剧本还是真诚回应？", heat: "热搜第一 · 热度 98.6" },
  { rank: 2, tag: "人设争议", title: "「人间清醒」人设一个月后光速塌房", brief: "账号考古被翻出，粉丝从拥护到反噬，人设经济为何如此脆弱。", heat: "热度 95.2" },
  { rank: 3, tag: "舆论反转", title: "一场「明星被拍到」事件的两次大反转", brief: "真相没到、情绪先到，吃瓜群众如何被剪辑节奏牵着走。", heat: "热度 91.7" },
  { rank: 4, tag: "素人走红", title: "地铁小哥 72 小时爆红又归于平淡", brief: "被镜头选中的普通人，流量是机遇还是又一个循环？", heat: "热度 88.9" },
  { rank: 5, tag: "事件营销", title: "联名即热搜：跨界营销为何屡试不爽", brief: "两个看似无关的品牌捆绑出圈，背后的受众拼图逻辑。", heat: "热度 84.3" },
  { rank: 6, tag: "评论区风向", title: "「路人感言」席卷评论区：真路人还是分工号", brief: "满屏「本来路人的我」突然转粉，情绪合唱是怎么制造的。", heat: "热度 80.1" },
  { rank: 7, tag: "平台机制", title: "冷启动爆款：一条视频如何冲上热榜", brief: "分发机制、完播率、互动权重，平台才是最大的「场外推手」。", heat: "热度 76.4" },
  { rank: 8, tag: "危机公关", title: "致歉信模板化：盖章式道歉还管用吗", brief: "「已关注、会整改」成为标准话术，公众为何越来越不买账。", heat: "热度 72.8" },
];

export const pillars: Pillar[] = [
  { icon: "ri-megaphone-line", tag: "事件营销拆解", title: "热点是被「做」出来的", desc: "从借势到造势，拆解一场爆火事件的营销预算、节奏与曝光模型，看清品牌与机构怎样把「围观」换算成关注度。" },
  { icon: "ri-user-search-line", tag: "幕后推手追踪", title: "谁在暗中带节奏", desc: "顺着传播链条溯源：选题者、投放方、联动账号、剪辑手，识别热点背后的分工与层层转手的真实动机。" },
  { icon: "ri-message-3-line", tag: "舆论引导研究", title: "风向如何被调动", desc: "情绪、标签、阵营化，研究舆论从发酵到反转的每个拐点，看懂引导方如何借力打力、转移焦点。" },
  { icon: "ri-eye-2-line", tag: "真相与谣言之辨", title: "穿透表面看本质", desc: "在反转与辟谣之间，提供看待吃瓜事件的框架与信息核查方法，帮你理性吃瓜、不被谣言裹挟。" },
];

export const articles: Article[] = [
  {
    id: "a1",
    category: "事件营销",
    date: "2026.09.05",
    readMin: "6 分钟",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20collage%20style%20illustration%20of%20a%20megaphone%20and%20trending%20speech%20bubbles%20over%20warm%20cream%20paper%20texture%20with%20terracotta%20red%20and%20golden%20amber%20accents%2C%20hand%20drawn%20grains%2C%20vintage%20print%20poster%20aesthetic%2C%20flat%20graphic%20design%2C%20high%20detail&width=800&height=520&seq=gua-article-01&orientation=landscape",
    title: "「翻车」也是一门生意：从代言爆雷到道歉模板",
    excerpt: "品牌危机并不总是「坏事」，对某些操盘手而言，一次争议可能就是一次低成本的全国级曝光。",
    body: [
      "我们常默认「翻车 = 损失」，但在流量逻辑里，争议本身就是注意力。一次代言爆雷，能在几小时内把品牌送进所有用户的首页，这种曝光量用常规投放很难买到。于是部分品牌把「道歉」也当成了发布节点来经营。",
      "复盘几次典型翻车，你会发现节奏惊人地一致：先由大号或媒体抛出负面，引发第一波围观；随后正主沉默几个小时留足发酵窗口；在讨论热度见顶时发出措辞严谨的道歉，顺势把关注点从「错误本身」转向「态度是否诚恳」。",
      "所谓「公关危机」，本质是品牌与公众之间的叙事主导权之争。谁先定义这场事件的「主题」，谁就掌握了之后的走向。道歉模板化，正是因为模板能最大程度减少二次伤害，却也透支了公众的信任。",
      "站在吃瓜角度看，与其跟着情绪站队，不如先问一句：这个「瓜」从被抛出到被讨论，节奏是不是太丝滑了？太顺滑的剧情，往往只是有人写好的一集而已。",
    ],
  },
  {
    id: "a2",
    category: "幕后推手",
    date: "2026.09.04",
    readMin: "5 分钟",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20many%20hidden%20silhouettes%20pulling%20strings%20behind%20a%20stage%20curtain%2C%20warm%20terracotta%20and%20dark%20ink%20brown%20tones%2C%20grainy%20vintage%20print%20texture%2C%20cream%20background%2C%20flat%20poster%20design%2C%20high%20detail&width=800&height=520&seq=gua-article-02&orientation=landscape",
    title: "谁是那个「推手」？热搜背后的角色分工",
    excerpt: "一条热榜背后通常不止一个人。选题方、投放方、联动号、剪辑手各司其职，环环相扣。",
    body: [
      "很多人以为「推手」是某个神秘个体，实际上现代传播更像一条流水线。链条的起点是「选题」，有人负责判断什么内容具备引爆潜质；随后是「投放」，通过矩阵账号在特定时段把内容喂给算法。",
      "中游是「联动」，一批看似无关的账号在同一时间转发、评论，制造出「全网都在讨论」的错觉；最后是「剪辑」，把素材剪成最刺激情绪、最容易引发站队的版本——悬念前置、冲突拉满、真相后置。",
      "分工带来的好处是隐蔽：每个环节都是「正常」的内容创作者，很难被单独指认。可当事件呈现出高度的节奏一致性，就已经在提醒我们——有人在按照脚本推进。",
      "识别推手并非为了阴谋论，而是为了在吃瓜时多一层警惕：当剧情过于工整、正反双方都「恰到好处」地出场时，我们看到的也许不是全部，只是被人选好的那几帧。",
    ],
  },
  {
    id: "a3",
    category: "引爆机制",
    date: "2026.09.03",
    readMin: "4 分钟",
    cover: "https://readdy.ai/api/search-image?query=minimal%20editorial%20flat%20illustration%20of%20a%20fire%20starter%20and%20a%20domino%20effect%20chain%2C%20warm%20amber%20orange%20and%20cream%20palette%2C%20grainy%20paper%20texture%2C%20vintage%20print%20style%2C%20high%20contrast%2C%20high%20detail&width=800&height=520&seq=gua-article-03&orientation=landscape",
    title: "第一锤是谁砸的？引爆点的三种起手式",
    excerpt: "再大的瓜，也要有人先砸下第一锤。起手式的不同，决定了事件的天花板。",
    body: [
      "一场热点的爆发几乎都有个「起爆点」。最常见的是「爆料起手」：由营销号或所谓的知情人士抛出猛料，把悬念留足；这类事件的走向往往依赖后续有没有更多「实锤」跟进。",
      "第二种是「对比起手」：把两件原本不相干的事绑在一起，制造「塌房/双标」的对照，天然适合二次传播与站队，话题张力极高。",
      "第三种是「共情起手」：从一个让大众产生强烈代入感的个体遭遇切入，迅速唤起集体情绪。这类事件看似最「自然」，但也最容易在情绪退潮后被进一步追问动机。",
      "无论哪种起手，第一锤往往不是终点而是邀请函。它邀请算法、账号与吃瓜群众共同入场，把一个人的事，变成所有人的热闹。",
    ],
  },
  {
    id: "a4",
    category: "舆论引导",
    date: "2026.09.02",
    readMin: "5 分钟",
    cover: "https://readdy.ai/api/search-image?query=conceptual%20flat%20illustration%20of%20a%20roller%20coaster%20track%20looping%20with%20speech%20bubbles%20changing%20direction%2C%20warm%20crimson%20and%20cream%20tone%2C%20grainy%20vintage%20poster%20texture%2C%20high%20detail&width=800&height=520&seq=gua-article-04&orientation=landscape",
    title: "反转再反转：舆论为什么会被「来回牵着走」",
    excerpt: "事实在途中不断换挡，情绪却始终拉满。理解反转机制，才能不被任意一方绑架。",
    body: [
      "近年来的热门事件似乎都逃不开「反转」的宿命。前脚全网声讨，后脚真相反转又全网道歉。反转之所以频繁，是因为情绪跑得永远比事实快。",
      "在信息碎片化的环境里，第一波传播几乎不依赖完整事实——一个标签、一张截图、一句旁白就足够点燃讨论。当原始信息被放大到极致，任何补充细节都可能造成「剧情推翻」。",
      "反转的另一面是「预留空间」。成熟的操盘者会刻意在初版故事里留出模糊地带，以便后续根据舆论风向「递进」输出新版本，让关注度始终维持在高位。",
      "对吃瓜群众而言，真正的功课是学会延迟判断：在核心证据未到位前，不对任何人定罪，也不把片面的情绪当成全部真相。等一等，瓜会更甜，也更安全。",
    ],
  },
  {
    id: "a5",
    category: "造神与反噬",
    date: "2026.09.01",
    readMin: "4 分钟",
    cover: "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20person%20on%20a%20pedestal%20with%20a%20camera%20lens%20as%20the%20spotlight%20and%20rising%20and%20falling%20crowd%20arrows%2C%20warm%20ochre%20and%20cream%2C%20grainy%20vintage%20print%2C%20high%20detail&width=800&height=520&seq=gua-article-05&orientation=landscape",
    title: "素人一夜走红：流量时代「造神」与「塌房」的双面叙事",
    excerpt: "镜头随机选中普通人，又在下一秒等待他犯错。走红本身，就是一场没有剧本的冒险。",
    body: [
      "从地铁小哥到素人博主，几乎每隔一阵就有一个「被镜头选中」的普通人。走红自带戏剧性：身份的反差、质朴的回应、错位的幽默，构成了天然的传播素材。",
      "但走红同时意味着隐私被放大、过去被考古。平台与观众很快会从「围观新鲜」转向「检验人设」，一旦发现言行与初期印象不符，热度就会瞬间反转为质疑。",
      "这是流量时代的双刃：被看见的机会前所未有地平等，被审视的风险也同样公平。对当事人而言，最难的不是一夜成名，而是如何面对随之而来的、铺天盖地的期待。",
      "而作为旁观者，我们或许也该提醒自己：镜头里的「完美主角」从来只是被剪辑出来的切片。让普通人回到普通，也是一种善意。",
    ],
  },
  {
    id: "a6",
    category: "情绪运营",
    date: "2026.08.30",
    readMin: "5 分钟",
    cover: "https://readdy.ai/api/search-image?query=abstract%20flat%20illustration%20of%20flames%20and%20motion%20lines%20fueling%20a%20comment%20section%20engine%2C%20warm%20red%20orange%20gold%20and%20cream%2C%20grainy%20paper%20texture%2C%20vintage%20poster%2C%20high%20detail&width=800&height=520&seq=gua-article-06&orientation=landscape",
    title: "评论区大战背后：情绪如何变成可运营的「燃料」",
    excerpt: "愤怒、共鸣、爽感……当情绪可以被归类与投放，评论区就成了一场可预估的火力秀。",
    body: [
      "评论区早已不只是交流空间，而是内容生态里权重极高的「互动原料」。平台算法会为高互动内容倾斜流量，而最能引爆互动的，往往是强烈的情绪——尤其是愤怒与共鸣。",
      "于是我们看到一种模板：正文负责制造情绪缺口，评论区负责补上。有的账号故意抛出争议观点吸引反驳，有的则铺满「路人粉」式评论引导从众。真与假混在一起，普通用户很难分辨。",
      "情绪运营的可怕之处在于它的可预估性：操盘者清楚哪类内容会点燃哪类人群，于是像投放广告一样投放情绪，反复收割注意力。热闹是他们的，时间却是你的。",
      "理性吃瓜的起点，就是意识到每次「上头」都可能是被精心设计的。停下来问自己：我是在判断这件事，还是在被这件事的情绪裹挟？",
    ],
  },
];

export const playbookSteps: PlaybookStep[] = [
  { no: "01", title: "预埋话题种子", desc: "在正式引爆前，通过小规模账号或外围渠道释放模糊信息，试探水温并测试关键词热度。", hint: "特征：隐约的「风声」与小范围讨论先行" },
  { no: "02", title: "多账号集中点火", desc: "在选定时段让一批账号同步发声、互相引用，制造「同一时刻全网都在聊」的集群效应，蹭上平台热榜。", hint: "特征：短时间内评论转发异常密集" },
  { no: "03", title: "塑造冲突阵营", desc: "把事件整理成便于站队的二元叙事，邀请大V站台、放大对立，让讨论从「事实」切换到「立场」。", hint: "特征：满屏「支持/反对」与标签化表达" },
  { no: "04", title: "圈层分层发酵", desc: "针对不同人群递进输出不同版本：情感号讲共情、段子号做梗、媒体号谈深度，让热度在不同圈层里接力。", hint: "特征：同一事件出现无数种「解读版本」" },
  { no: "05", title: "收割与转场", desc: "热度见顶后抛出正式回应或下一个新话题，把上一轮关注度平滑转移到新目标，完成流量接力。", hint: "特征：旧瓜被「更有爆点」的新瓜迅速覆盖" },
];

export const tips: Tip[] = [
  { icon: "ri-pause-circle-line", title: "让子弹飞一会儿", desc: "真相反转频繁的时代，先按捺住表态冲动，等核心信息与多方说法对齐后再下结论。" },
  { icon: "ri-user-follow-line", title: "追源不看搬运", desc: "尽量回到当事人与首发方查看原始信息，警惕只给你「剪辑切片」的搬运号与二次解读。" },
  { icon: "ri-focus-3-line", title: "警惕标签化", desc: "当一件事被高度简化为一个词或一张对立图时，通常意味着复杂真相已被有意裁剪。" },
  { icon: "ri-shield-check-line", title: "保护真实个体", desc: "吃瓜可，网暴不可。在事实澄清前，不传播未经证实的个人隐私与恶意揣测。" },
];

export const faqs: Faq[] = [
  { q: "什么是「吃瓜事件营销」？", a: "吃瓜事件营销，是指品牌、机构或个人借社会热点或主动制造话题，把大众的围观与讨论转化为关注度、流量或商业价值的一套运作手法。它既包括「借势」现成的热点，也包括「造势」——提前策划一场看似自然爆发的事件。理解它，能帮你看清许多「一夜爆火」背后真实的存在逻辑。" },
  { q: "为什么很多热点总感觉有人在「推」？", a: "因为真正能引爆全网的话题，确实常被有意识地推进。现代传播存在清晰分工：选题判断、多账号投放、联动转发、情绪剪辑等环节相互配合，才能在短时间形成集群效应。识别这种节奏的一致性，是辨别「被推动」热点的重要线索。" },
  { q: "怎么判断一个热点是不是炒作？", a: "可以从几点观察：剧情是否过于工整、节奏是否异常顺滑；正反双方是否「恰好」同时出场；讨论是否被快速简化为站队；以及事件是否有明确的、可被收割的关注目标。当然，判断炒作不等于否定事件里的真实个体，两者并不冲突。" },
  { q: "吃瓜时如何避免被带节奏？", a: "核心是延迟判断与多方核实：暂缓表态，先回到原始信息源，对照事件各方的说法，警惕只展示片段的搬运内容。同时管理好自己的情绪，当你想「立刻开骂」时，往往是最容易被引导的时刻。" },
  { q: "平台和媒体在热点传播中扮演什么角色？", a: "平台的分发算法是热点能否破圈的关键变量，它偏好高互动与情绪化内容；媒体与创作者则决定了事件被如何「翻译」给公众。它们既是传播放大器，也承担着核实与平衡的责任，是传播链条里不容忽视的环节。" },
  { q: "理性吃瓜能带来什么价值？", a: "理性吃瓜不只是避免被忽悠，更是一种媒介素养的练习：它训练你在海量信息里辨别真伪、看清利益动机、保持独立思考。长期来看，这能让你更从容地参与公共讨论，也避免因冲动言行造成对他人的伤害。" },
];

export const reviews: Review[] = [
  { name: "林小姐 · 新媒体从业者", role: "常读用户", quote: "以前只觉得瓜热闹，看了几篇拆解后才明白背后有这么多门道，现在吃瓜都吃得更「专业」了。" },
  { name: "阿哲 · 大学生", role: "社区用户", quote: "最喜欢那些「让子弹飞一会儿」的提醒，追热点容易上头，这里总能让我冷静下来想一层。" },
  { name: "老王 · 传统行业管理者", role: "订阅用户", quote: "把舆论引导和危机公关讲得通俗又不失深度，对理解当下的传播环境很有帮助。" },
];

export const categories = ["事件营销", "幕后推手", "舆论引导", "真相核查", "防晕指南", "关于我们"];